import type { Address_Schema, AddressId_Schema } from "@/services/addresses/addressSchema";
import type { z } from "zod";

export type AddressId = z.infer<typeof AddressId_Schema>;
export type Address = z.infer<typeof Address_Schema>;

export type Address_CreationData = {
  externalIdentification: string;

  email: string;
  phone: string;

  name: string;
  street: string;
  streetNumber: string;
  city: string;
  postCode: string;
  country: string;

  type: AddressType;
};

export enum AddressType {
  Shipping = "delivery",
  Personal = "personal",
  Zasilkovna = "zasilkovna",
}

export type Address_ShippingType = Address & {
  type: AddressType.Shipping;
};
